module.exports = __webpack_public_path__ + "static/img/4.ffe43b93.jpg";